import core = egr.wcf.core;
import utils = egr.wcf.utils;
import { AppFileApiHelper } from './AppFileApiHelper';

export class AppDocumentContainer implements core.io.DocumentContainer {
    public static readonly ChunkSize: number = 5242880; // 5 MB

    constructor(protected folder: string) {
    }

    public async addFile(data: ArrayBuffer | string, filename: string, pCompress?: boolean): Promise<void> {
        return await AppFileApiHelper.writeFile(this.getPath(filename), data);
    }

    public addFileFromCache(filename: string, compress?: boolean): Promise<boolean> {
        return Promise.resolve(false);
    }

    public addFileFromUrl(url: string, filename: string, binary: boolean, compress?: boolean): Promise<void> {
        if (utils.string.isNullOrEmpty(url) || utils.string.isNullOrEmpty(filename)) {
            return Promise.reject(new Error(utils.ERR_INVALID_ARGUMENT));
        }

        return utils.async.ajax<string | ArrayBuffer>('GET', url, null, {
            responseType: binary ? 'arraybuffer' : 'text'
        }).then((response) => {
            return (this.addFile(response, filename, compress));
        });
    }

    public async getFile(pFilename: string, pBinary: false): Promise<string>;
    public async getFile(pFilename: string, pBinary: true): Promise<ArrayBuffer>;
    public async getFile(filename: string, binary: boolean): Promise<ArrayBuffer | string> {
        const content: ArrayBuffer | string | null = await AppFileApiHelper.readFile(this.getPath(filename), binary ? 'base64' : '');

        if (content == null) {
            return Promise.reject(new core.io.FileNotFoundError(filename));
        }

        return content;
    }

    public listFiles(pFolderPath?: string): Promise<Array<string>> {
        return Promise.resolve([]);
    }

    private getPath(filename: string): string {
        return this.folder + filename;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/AppDocumentContainer.ts